import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiInfo, FiShare2, FiUser, FiUsers, FiGlobe, FiMonitor } = FiIcons;

const MobileHeader = ({ calculationMode, onModeChange, onShowInfo, onShare, results, lang, onLangChange, langLabel, isPwdOnly }) => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <>
      <div className="bg-white/95 border-b border-gray-200 md:hidden sticky top-0 z-30">
        <div className="flex items-center justify-between p-4">
          <div className="flex items-center">
            <SafeIcon icon={calculationMode === 'group' ? FiUsers : calculationMode === 'pos' ? FiMonitor : FiUser} className="text-blue-600 text-xl mr-2" />
            <div>
              <p className="text-lg font-bold text-gray-800">{isPwdOnly ? 'PWD Calc' : 'Senior/PWD Calc'}</p>
              <p className="text-xs text-gray-500">
                {calculationMode === 'group' ? 'Group Mode' : calculationMode === 'pos' ? 'POS/Resto Mode' : 'Individual Mode'}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            {/* Language Toggle */}
            <motion.button
              whileTap={{ scale: 0.95 }}
              onClick={onLangChange}
              className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 font-black text-xs border border-blue-100 uppercase"
            >
              <SafeIcon icon={FiGlobe} className="text-sm" />
              {langLabel}
            </motion.button>

            {results && (
              <motion.button 
                whileTap={{ scale: 0.95 }}
                onClick={onShare}
                className="p-2 rounded-full bg-blue-50 text-blue-600"
                aria-label="Share results"
              >
                <SafeIcon icon={FiShare2} className="text-lg" />
              </motion.button>
            )}

            <motion.button 
              whileTap={{ scale: 0.95 }}
              onClick={() => setShowMenu(!showMenu)}
              className="p-2 rounded-full bg-gray-50 text-gray-600"
              aria-label="Menu"
            >
              <SafeIcon icon={showMenu ? FiX : FiMenu} className="text-lg" />
            </motion.button>
          </div>
        </div>

        {/* Mode Toggle */}
        <div className="px-4 pb-3">
          <div className="grid grid-cols-3 gap-2 bg-gray-100 p-1.5 rounded-xl">
            <motion.button
              whileTap={{ scale: 0.98 }}
              onClick={() => onModeChange('individual')}
              className={`relative py-2.5 px-1 rounded-lg font-bold text-xs transition-all ${
                calculationMode === 'individual'
                  ? 'bg-white text-blue-700 shadow-md ring-2 ring-blue-500 z-10'
                  : 'text-gray-600 hover:bg-gray-200/50'
              }`}
            >
              <SafeIcon icon={FiUser} className="inline mr-1 text-sm" /> Indv
            </motion.button>
            <motion.button
              whileTap={{ scale: 0.98 }}
              onClick={() => onModeChange('group')}
              className={`relative py-2.5 px-1 rounded-lg font-bold text-xs transition-all ${
                calculationMode === 'group'
                  ? 'bg-white text-blue-700 shadow-md ring-2 ring-blue-500 z-10'
                  : 'text-gray-600 hover:bg-gray-200/50'
              }`}
            >
              <SafeIcon icon={FiUsers} className="inline mr-1 text-sm" /> Group
            </motion.button>
            <motion.button
              whileTap={{ scale: 0.98 }}
              onClick={() => onModeChange('pos')}
              className={`relative py-2.5 px-1 rounded-lg font-bold text-xs transition-all ${
                calculationMode === 'pos'
                  ? 'bg-white text-blue-700 shadow-md ring-2 ring-blue-500 z-10'
                  : 'text-gray-600 hover:bg-gray-200/50'
              }`}
            >
              <SafeIcon icon={FiMonitor} className="inline mr-1 text-sm" /> POS
              <span className="absolute -top-2 -right-1 bg-gradient-to-r from-red-500 to-rose-500 text-white text-[8px] font-black px-1.5 py-0.5 rounded-full shadow-sm border border-white z-20">
                MUST TRY
              </span>
            </motion.button>
          </div>
        </div>

        {/* Dropdown Menu */}
        {showMenu && (
          <motion.div 
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="absolute top-full left-0 right-0 bg-white border-b border-gray-200 shadow-lg z-40"
          >
            <div className="p-4 space-y-3">
              <motion.button 
                whileTap={{ scale: 0.98 }}
                onClick={() => { onShowInfo(); setShowMenu(false); }}
                className="w-full flex items-center p-3 rounded-lg bg-gray-50 text-gray-700 hover:bg-gray-100 transition-colors"
              >
                <SafeIcon icon={FiInfo} className="mr-3 text-blue-600" />
                <div className="text-left">
                  <div className="font-medium">How to Use</div>
                  <div className="text-sm text-gray-500">Learn about discounts</div>
                </div>
              </motion.button>
            </div>
          </motion.div>
        )}
      </div>
    </>
  );
};

export default MobileHeader;